const home = {
    defaultPortalName: 'Portal',
    heroSubtitle: 'Verwalte den Zugriff auf deine Automatisierungsplattform',
    providerCardTitle: 'Provider-Portal',
    providerCardDescription: 'Verwalte deine API-Produkte und Kunden',
    providerCardCta: 'Melde dich an, um dein Provider-Dashboard zu öffnen',
    customerCardTitle: 'Kundenportal',
    customerCardDescription: 'Greife auf deine API-Abonnements zu',
    customerCardCtaAuthenticated: 'Zurück zu deiner Abonnementübersicht',
    customerCardCtaAnonymous: 'Sieh dir die kommende Kundenerfahrung an',
  } as const;

export default home;
